/**
 * Limited-time promotional trial — DISPLAY COPY ONLY.
 *
 * Keep in sync with PROMO_TRIAL in
 * ai-voice-typescript/src/config/pricing.config.ts — the backend is the
 * source of truth for the trial length actually granted at signup.
 *
 * The window check runs client-side at render time, so the copy self-expires
 * after signupEnd without a redeploy (a redeploy is still recommended for
 * prerendered pages).
 */
export const PROMO_TRIAL = {
  enabled: true,
  name: "Summer Special",
  signupStart: "2026-07-01", // inclusive
  signupEnd: "2026-08-31", // inclusive
  trialDays: 90,
};

export const DEFAULT_TRIAL_DAYS = 30;

// True while today (browser-local date) is inside the promo signup window.
export function isPromoActive() {
  if (!PROMO_TRIAL.enabled) return false;
  const d = new Date();
  const today = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate()
  ).padStart(2, "0")}`;
  return today >= PROMO_TRIAL.signupStart && today <= PROMO_TRIAL.signupEnd;
}

// Trial length to display today (self-expires after the promo window).
export function getDisplayTrialDays() {
  return isPromoActive() ? PROMO_TRIAL.trialDays : DEFAULT_TRIAL_DAYS;
}
